export var getBrowserLanguage = function () {
    var language = navigator.language;
    return language;
};
export var getCorrectLocaleByBrowser = function (locales) {
    if (locales === void 0) { locales = []; }
    var browserLocale = getBrowserLanguage();
    if (locales.includes(browserLocale))
        return browserLocale;
    return locales === null || locales === void 0 ? void 0 : locales[0];
};
